export function buildBasicQuery(searchText: string): string {
  const trimmed = searchText.trim();
  if (!trimmed) return 'sort @timestamp desc';
  // Escape regex metacharacters for safe use in /pattern/
  const escaped = trimmed.replace(/[.*+?^${}()|[\]\\\/]/g, '\\$&');
  return `filter @message like /${escaped}/ | sort @timestamp desc`;
}
